export default __webpack_public_path__ + "static/images/wow/WowIcon.png";